import React from 'react';

import { Grid, useMediaQuery } from '@material-ui/core';

import errorPageStyles from './ErrorPage.style';
import PropTypes from 'prop-types';

function MultiLineResponsiveText(props) {
	const { isSmallScreen, msg1, msg2 } = props;
	const classes = errorPageStyles({ isSmallScreen });
	const fancyText = useMediaQuery('(max-width:767px)');

	return (
		<>
			{fancyText ? (
				<Grid
					container
					display="flex"
					justifyContent="center"
					mt={0}
					mx={3}
					direction="column"
					alignItems="center">
					<Grid item xs={12} sm={12} md={12} lg={12} className={classes.responsiveLabelSmall}>
						{msg1}
					</Grid>
					<Grid item xs={12} sm={12} md={2} className={classes.responsiveLabelSmall}>
						{msg2}
					</Grid>
				</Grid>
			) : (
				<pre className={classes.responsiveLabel}>{`${msg1} ${msg2}`}</pre>
			)}
		</>
	);
}

MultiLineResponsiveText.propTypes = {
	isSmallScreen: PropTypes.bool
};

export default MultiLineResponsiveText;
